export const schoolOptions = [
    { value: '서울대학교', label: '서울대학교'},
    { value: '연세대학교', label: '연세대학교'},
    { value: '경희대학교', label: '경희대학교'}
];

export const majorOptions = [
    { value: '전자공학', label: '전자공학'},
    { value: '컴퓨터공학', label: '컴퓨터공학'},
    { value: '기계공학', label: '기계공학'}
];

export const kindofcompanyOptions = [
    { value: '대기업', label: '대기업'},
    { value: '중견기업', label: '중견기업'},
    { value: '스타트업', label: '스타트업'},
    { value: '연구소', label: '연구소'},
]

export const fieldTagOptions = [
    { value: '반도체', label: '반도체'},
    { value: 'IT', label: 'IT'},
    { value: '바이오', label: '바이오'},
    { value: '커리어', label: '커리어'},
]

export const fieldOptions = [
    // { value: '연구/개발', label: '연구/개발'},
    { value: '반도체개발', label: '반도체개발'},
    { value: '반도체생산', label: '반도체생산'},
    { value: '반도체3', label: '반도체3'},
    { value: '반도체4', label: '반도체4'},
    { value: '반도체5', label: '반도체5'},
    { value: '반도체6', label: '반도체6'},
    { value: '반도체7', label: '반도체7'},
    { value: 'IT개발', label: 'IT개발'},
    { value: 'IT디자인', label: 'IT디자인'},
    { value: '바이오임상', label: '바이오임상'},
    { value: '바이오영업', label: '바이오영업'},
    { value: '임시2', label: '임시2'},
    { value: '임시3', label: '임시3'},
    { value: '임시4', label: '임시4'},
    { value: '임시5', label: '임시5'},
]

export const fieldOptions_c = [
    // { value: '연구/개발', label: '연구/개발'},
    { value: '커리어', label: '커리어'},
    { value: '반도체개발', label: '반도체개발'},
    { value: '반도체생산', label: '반도체생산'},
    { value: '반도체3', label: '반도체3'},
    { value: '반도체4', label: '반도체4'},
    { value: '반도체5', label: '반도체5'},
    { value: '반도체6', label: '반도체6'},
    { value: '반도체7', label: '반도체7'},
    { value: 'IT개발', label: 'IT개발'},
    { value: 'IT디자인', label: 'IT디자인'},
    { value: '바이오임상', label: '바이오임상'},
    { value: '바이오영업', label: '바이오영업'},
    { value: '임시2', label: '임시2'},
    { value: '임시3', label: '임시3'},
    { value: '임시4', label: '임시4'},
    { value: '임시5', label: '임시5'},
]

export const SMfieldOptions = [
    { value: '반도체개발', label: '반도체개발'},
    { value: '반도체생산', label: '반도체생산'},
    { value: '반도체3', label: '반도체3'},
    { value: '반도체4', label: '반도체4'},
    { value: '반도체5', label: '반도체5'},
    { value: '반도체6', label: '반도체6'},
    { value: '반도체7', label: '반도체7'},
]

export const ITfieldOptions = [
    { value: 'IT개발', label: 'IT개발'},
    { value: 'IT디자인', label: 'IT디자인'},
]

export const BMfieldOptions = [
    { value: '바이오임상', label: '바이오임상'},
    { value: '바이오영업', label: '바이오영업'},
]


export const SMjobOptions = [
    [
        { value: '소자개발', label: '소자개발'},
        { value: '회로설계', label: '회로설계'},
        { value: '공정', label: '공정'},
    ],
    [
        { value: '공정', label: '공정'},
        { value: '생산', label: '생산'},
    ]
]

export const ITjobOptions = [
    [
        { value: '백엔드개발자', label: '백엔드개발자'},
        { value: '프론트개발자', label: '프론트개발자'},
        { value: '데이터사이언티스트', label: '데이터사이언티스트'},
    ],
    [
        { value: 'UI', label: 'UI'},
        { value: '포토샵/일러', label: '포토샵/일러'},
    ]
]

export const BMjobOptions = [

]

export const toolOptions = [

]

export const companyOptions = [
    { value: '삼성전자', label: '삼성전자'},
    { value: '카카오', label: '카카오'},
    { value: '네이버', label: '네이버'},
]

export const paperOptions = [
    { value: '제출', label: '제출'},
    { value: '심사중', label: '심사중'},
    { value: '게재', label: '게재'},
]


export const degreeOptions = [
    { value: '학사 과정', label: '학사 과정'},
    { value: '학사 졸업', label: '학사 졸업'},
    { value: '석사 과정', label: '석사 과정'},
    { value: '석사 졸업', label: '석사 졸업'},
    { value: '박사(통합) 과정', label: '박사(통합) 과정'},
    { value: '박사(통합) 졸업', label: '박사(통합) 졸업'},
]

export const rankOptions=[
    { value: '사원', label: '사원'},
    { value: '대리', label: '대리'},
    { value: '과장', label: '과장'},
]


export const lookOptions = [
    { value: '0', label: '적극적으로 찾는 중'},
    { value: '1', label: '당장은 생각이 없지만 고려해볼 것'},
]


export const freshOptions = [
    { value: "신입(학생)", label: '신입(학생)'},
    { value: "0-4", label: '0-4'},
    { value: "4-8", label: '4-8'},
    { value: "8-12", label: '8-12'},
    { value: "12 이상", label: '12 이상'},
]

export const freshOptionsWithNull = [
    { value: null, label: '없음'},
    { value: "신입(학생)", label: '신입(학생)'},
    { value: "0-3", label: '0-3'},
    { value: "3-5", label: '3-5'},
    { value: "5-7", label: '5-7'},
    { value: "7 이상", label: '7 이상'},
]

export const statusOptions = [
    { value: "7%", label: '7%'},
    { value: "HH", label: 'HH'},
]

export const languageOptions = [
    { value: "영어", label: '영어'},
    { value: "한국어", label: '한국어'},
    { value: "일본어", label: '일본어'},
]

export const abilityOptions = [
    { value: 'Python', label: 'Python'},
    { value: 'Javascript', label: 'Javascript'},
    { value: 'CAD', label: 'CAD'},
    { value: '개발', label: '개발'},
    { value: '경영', label: '경영'},
];

export const interestOptions = [
    { value: '자율주행', label: '자율주행'},
    { value: '인공지능', label: '인공지능'},
    { value: '쇼핑몰', label: '쇼핑몰'},
    { value: 'O2O', label: 'O2O'},
    
];

export const tagOptions = [
    { value: '워라벨', label: '워라벨'},
    { value: '연봉', label: '연봉'},
    { value: '스타트업', label: '스타트업'},
    { value: '인원성장', label: '인원성장'},
    { value: '사내식당', label: '사내식당'},
    { value: '사내주차', label: '사내주차'},
    { value: '휴게실', label: '휴게실'},
    { value: '헬스장', label: '헬스장'},

];

export const nationOptios = [
    { value: '대한민국', label: '대한민국'},
    { value: '미국', label: '미국'},
    { value: '일본', label: '일본'},
]


export const yearOptions = [
    { value: '1970', label: '1970'},
    { value: '1971', label: '1971'},
    { value: '1972', label: '1972'},
    { value: '1973', label: '1973'},
    { value: '1974', label: '1974'},
    { value: '1975', label: '1975'},
    { value: '1976', label: '1976'},
    { value: '1977', label: '1977'},
    { value: '1978', label: '1978'},
    { value: '1979', label: '1979'},
    { value: '1980', label: '1980'},
    { value: '1981', label: '1981'},
    { value: '1982', label: '1982'},
    { value: '1983', label: '1983'},
    { value: '1984', label: '1984'},
    { value: '1985', label: '1985'},
    { value: '1986', label: '1986'},
    { value: '1987', label: '1987'},
    { value: '1988', label: '1988'},
    { value: '1989', label: '1989'},
    { value: '1990', label: '1990'},
    { value: '1991', label: '1991'},
    { value: '1992', label: '1992'},
    { value: '1993', label: '1993'},
    { value: '1994', label: '1994'},
    { value: '1995', label: '1995'},
    { value: '1996', label: '1996'},
    { value: '1997', label: '1997'},
    { value: '1998', label: '1998'},
    { value: '1999', label: '1999'},
    { value: '2000', label: '2000'},
    { value: '2001', label: '2001'},
    { value: '2002', label: '2002'},
    { value: '2003', label: '2003'},
    { value: '2004', label: '2004'},
    { value: '2005', label: '2005'},
    { value: '2006', label: '2006'},
    { value: '2007', label: '2007'},
    { value: '2008', label: '2008'},
    { value: '2009', label: '2009'},
    { value: '2010', label: '2010'},
    { value: '2011', label: '2011'},
    { value: '2012', label: '2012'},
    { value: '2013', label: '2013'},
    { value: '2014', label: '2014'},
    { value: '2015', label: '2015'},
    { value: '2016', label: '2016'},
    { value: '2017', label: '2017'},
    { value: '2018', label: '2018'},
    { value: '2019', label: '2019'},
    { value: '2020', label: '2020'},
    { value: '2021', label: '2021'},
    { value: '2022', label: '2022'},
]

export const monthOptions = [
    { value: '1', label: '1'},
    { value: '2', label: '2'},
    { value: '3', label: '3'},
    { value: '4', label: '4'},
    { value: '5', label: '5'},
    { value: '6', label: '6'},
    { value: '7', label: '7'},
    { value: '8', label: '8'},
    { value: '9', label: '9'},
    { value: '10', label: '10'},
    { value: '11', label: '11'},
    { value: '12', label: '12'},
]